<template>
  <div class="box">
    <div class="block-title">充电月排行</div>
    <div class="boxnav">
      <table class="table1" width="100%" height="220px" border="0" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th>充电站</th>
            <th>充电电量</th>
            <th>充电费用</th>
            <!-- <th>充电次数</th> -->
          </tr>
        </thead>
        <tbody>
          <template v-if="stationsRanking && stationsRanking.length > 0">
            <tr v-for="(item, index) in stationsRanking" :key="index">
              <td class="td-label">
                <span class="text-t" :title="item.StationName">{{ item.StationName }}</span>
              </td>
              <td class="td-kwh">
                <span class="text-w">{{ currencyFormat(item.ChargeKwh) }} 度</span>
              </td>
              <td class="td-cost">
                <span class="text-b">{{ currencyFormat(item.ChargeCost) }} 元</span>
              </td>
              <!-- <td class="td-num">
                <span class="text-d">{{ currencyFormat(item.ChargeNum) }} 次</span>
              </td> -->
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
	data() {
		return {
			stationsRanking: [],
		}
	},
	mounted() {
		
	},
	methods: {
		setData(data) {
			this.stationsRanking = data;
		},
		currencyFormat(value) {
			if (!value) value = 0;
			const formatter = new Intl.NumberFormat('zh-CN', { useGrouping: true });
			return formatter.format(value);
		}
	}
}
</script>

<style scoped>
@import '../style.css';
.content {
  background: -webkit-radial-gradient(50% 35%, farthest-corner, #034f8e, #034987, #02366d, #002353);
  color: white;
}

/deep/ .td-label {
  text-align: left !important;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .td-kwh,
/deep/ .td-cost,
/deep/ .td-num {
  text-align: right !important;
}
/* .boxnav .text-d::before {
  content: '↑ ';
}

.boxnav .text-s::before {
  content: '↓ ';
} */
</style>
